export default "__VITE_ASSET__BN525WTm__"